import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import classNames from 'classnames';
import {colorPaletteMarkupPanel} from '../../../themes/colors';
import PropTypes from 'prop-types';

@observer
class MarkupColorPicker extends Component {

    @action changeColor = (color) => {
        this.props.changeColor(color);
    };

    render() {
        const {activeColor} = this.props;

        return colorPaletteMarkupPanel.map((color, index) => {
            const palleteClasses = classNames({
                "color-btn": true,
                "active-color": color === activeColor,
            });
            return <span key={index} className={palleteClasses} style={{backgroundColor: color}} onClick={() => this.changeColor(color)}></span>;
        });
    };
}

MarkupColorPicker.propTypes = {
    changeColor: PropTypes.func.isRequired
};


export default MarkupColorPicker;
